export const BASE_GRAPHQL_URL = `${window.location.origin}/api/graphql/`;
export const BASE_SEARCH_GRAPHQL_URL = `${window.location.origin}/api/search/graphql/`;
